import { Component, Host, h, Element, State, Prop, Listen, Watch } from '@stencil/core';
import { isPlatform } from '@baloise/ds-core';
@Component({
  tag: 'bam-infographic-facts',
  styleUrl: 'bam-infographic-facts.scss',
  shadow: false,
})
export class BamInfographicFacts {
  @Element() el: HTMLElement;

  @Prop({ attribute: 'active-item' }) initialActive?: number;
  @Prop() backgroundColor!: 'yellow' | 'purple' | 'green' | 'red';
  @Prop() graphicType: 'chart' | 'figures' | 'figures-default' | 'aims' = 'figures-default';
  @Prop() chartValues: string;
  @Prop() chartTitle: string;
  @Prop() chartAddon: string;

  @State() activeItem: number = 1;
  @State() isMobile: boolean = false;

  private chartItems = [];

  @Listen('activeChartItemChanged')
  handleActiveItemChange(e) {
    this.activeItem = e.detail;
    this.setActiveElement(this.activeItem);
  }

  @Listen('resize', { target: 'window' })
  async resizeHandler() {
    this.isMobile = isPlatform('mobile');
  }

  @Watch('isMobile')
  watchPropHandler(newValue: string, oldValue: string) {
    if (newValue !== oldValue && !newValue) {
      console.log('not mobile');
      this.getContentItems();
    }
  }

  getContentItems = () => {
    const headerElements = this.el.querySelectorAll('.bam-infographic-facts__item-header');
    const contentElements = this.el.querySelectorAll('.bam-infographic-facts__item-content');

    headerElements.forEach(el => {
      const id = parseInt(el.id.slice(-1));
      const contentObject = [id, el, contentElements[id - 1]];
      this.chartItems.push(contentObject);
    });
  };

  setActiveElement = (id: number) => {
    this.chartItems.forEach(item => {
      if (item[0] === id) {
        item[1].classList.remove('is-hidden-content');
        item[2].classList.remove('is-hidden-content');
      } else {
        item[1].classList.add('is-hidden-content');
        item[2].classList.add('is-hidden-content');
      }
    });
  };

  // ############################################################# //
  // ------------------------- Lifecycle ------------------------- //
  // ############################################################# //
  componentDidLoad() {
    this.getContentItems();
    this.setActiveElement(this.initialActive ? this.initialActive : this.activeItem);
    this.isMobile = isPlatform('mobile');
  }

  // ############################################################## //
  // --------------------------- Render --------------------------- //
  // ############################################################## //
  render() {
    return (
      <Host
        class={{
          'bam-infographic-facts': true,
          [`bam-infographic-facts--is-${this.graphicType}`]: true,
        }}
      >
        <bam-page-section
          class={{
            fullwidth: true,
            [`bg-${this.backgroundColor}-1`]: true,
          }}
        >
          {this.graphicType === 'chart' && (
            <div class="container">
              <slot name="link"></slot>
              <slot name="mobile-content"></slot>
              <div class="bam-infographic-facts__content mobile:hidden">
                <bam-chart chart-type="pie" color={this.backgroundColor} values={this.chartValues} initial-active="1">
                  <div slot="chart-text" class="bam-chart__text">
                    <p class="title percentage">{this.chartTitle}</p>
                    {this.chartAddon && <span>{this.chartAddon}</span>}
                  </div>
                </bam-chart>
                <slot></slot>
              </div>
            </div>
          )}
          {this.graphicType === 'figures' && <slot name="figures"></slot>}
          {this.graphicType === 'figures-default' && <slot name="figures-default"></slot>}
        </bam-page-section>
      </Host>
    );
  }
}
